export default __webpack_public_path__ + "static/media/330_business05-fr-mobile.f10ab18c.png";